import axios from 'axios';
import React, { Component } from 'react'
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";
import { BASEURL } from '../Config';
import { getSelectedOrderId } from '../modules/reducers';

export class ViewOrderDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: {},
            orderProducts: [],
            student: {}
        }
    }
    componentDidMount() {
        this.fetchOrderById();
    }

    fetchOrderById() {
        axios.get(`${BASEURL}/api/v1/order/fetchByOid/${this.props.selectedOrderId}`)
            .then(res => {
                if (res.status === 200) {
                    let order = this.state.order;
                    order = res.data
                    order.createdDate = new Date(res.data.createdAt).toLocaleDateString();
                    this.setState({
                        order,
                        orderProducts: res.data.products,
                        student: res.data.student
                    })
                }
            })
            .catch(err => {
                console.log('Fetchall orders err', err);
            })
    }

    render() {
        return (
            <div className='viewOrderDiv'>
                <div className='card mb-3'>
                    <div className='card-body'>
                        {/* <div className="row header-row">
                            <div className="col-md-6 col-sm-6">
                                <img
                                    src="images/pelican_icon.jpg"
                                    alt="Company Logo"
                                    className="img-fluid rounded"
                                    style={{ maxWidth: "150px" }}
                                />
                            </div>
                            <div className="col-md-6 col-sm-6 header-text-col">
                                <h3 className="fw-bold">PELICAN PUBLISHING HOUSE</h3>
                                <p>Plot No: 121/5, Phase Il, Hyderabad - 500 051.</p>
                                <p>Email : pelicanpublishinghouse@gmail.com</p>
                                <p>Ph. No: 72070 20943. Pan No: AASFP1592.</p>
                            </div>
                        </div> */}
                        <div className="row  text-black">
                            <div className="col-sm-4">
                                <strong>Date:</strong> {this.state.order.createdDate}
                            </div>
                            <div className="col-sm-4">
                                <strong>Order ID:</strong> {this.state.order.orderId}
                            </div>
                            <div className="col-sm-4">
                                <strong>Razorpay ID:</strong> {this.state.order.rzpPaymentId}
                            </div>
                        </div>
                        <hr />
                        <div className="row text-black">
                            <div className="col-sm-6 text-sm-end order-sm-1">
                                {" "}
                                <strong>Pay To:</strong>
                                <address>
                                    Pelican Publshing House,
                                    <br />
                                    Hyderabad, Telangana, India
                                    <br />
                                    500051
                                </address>
                            </div>
                            <div className="col-sm-6 order-sm-0">
                                <strong>Invoiced To:</strong>
                                <address>
                                    {this.state.order.studentName}
                                    <br />
                                    {this.state.order.address}
                                    <br />
                                    {this.state.order.state}
                                    <br />
                                    {this.state.order.zip}
                                </address>
                            </div>
                        </div>
                        <hr />
                        <div className="row  text-black">
                            <div className="col-sm-6">
                                <strong>School Name:</strong> {this.state.order.schoolName}
                            </div>
                            <div className="col-sm-3">
                                <strong>Email:</strong> {this.state.order.email}
                            </div>
                            <div className="col-sm-3">
                                <strong>Phone:</strong> {this.state.order.phone}
                            </div>
                        </div>
                        <div className="row text-black mt-2">
                            <div className="col-sm-6">
                                <strong>Student Name:</strong> {this.state.order.studentName}
                            </div>
                            {this.state.order.products?.[0]?.className && (
                                <div className="col-sm-6">
                                    <strong>Class:</strong> {this.state.order.products[0].className}
                                </div>
                            )}
                            {this.state.order.products?.[0]?.orderType === 'uniformProducts' && (
                                <div className="col-sm-12 mt-1">
                                    <span className='badge badge-warning' style={{ fontSize: '0.85em' }}>Uniform Products Order</span>
                                </div>
                            )}
                        </div>
                        <hr />
                        <div className='row'>

                            {this.state.orderProducts.length > 0 ? <>
                                {this.state.orderProducts.map((item, idx) => (
                                    <div className='col-md-12'>
                                        <p className='text-black text-center productDetails'><strong>Product Details</strong></p>
                                        <strong className='text-black'>Product {idx + 1}</strong>
                                        <div>
                                            <p className='mb-0 text-black'><strong>Name: </strong>{item.productSetName}</p>
                                            <p className='mb-0 text-black'><strong>Product Total: </strong>{item.price}</p>
                                        </div>

                                        {item.orderType === 'uniformProducts' && item.categories.uniformProducts && item.categories.uniformProducts.length > 0 ? (
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <span className="text-primary">Uniform Products</span></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                <th width={'100px'}>Size</th>
                                                                <th width={'60px'}>Qty</th>
                                                                <th width={'115px'}>Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.uniformProducts.map((element, index) => (
                                                                <tr key={index}>
                                                                    <td>{element.name}</td>
                                                                    <td>{element.selectedSize}</td>
                                                                    <td>{element.quantity || 1}</td>
                                                                    <td>₹{element.price}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        ) : null}
                                        {item.categories.languageProducts && item.categories.languageProducts.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Language: <sapn className="text-primary">{item.languageName}</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                {/* <th width={'100px'}>Qty</th> */}
                                                                {/* <th width={'145px'}>Unit Price (Rs.)</th> */}
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.languageProducts.map((element, index) => {
                                                                return (
                                                                    <tr >
                                                                        <td>{element.pname}</td>
                                                                        {/* <td>{element.qty}</td> */}
                                                                        {/* <td>₹{element.price}</td> */}
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </>
                                            : ''}
                                        {item.categories.books && item.categories.books.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Books</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                {/* <th width={'100px'}>Qty</th> */}
                                                                {/* <th width={'145px'}>Unit Price (Rs.)</th> */}
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.books.map((element, index) => {
                                                                return (
                                                                    <tr >
                                                                        <td>{element.pname}</td>
                                                                        {/* <td>{element.qty}</td> */}
                                                                        {/* <td>₹{element.price}</td> */}
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </>
                                            : ''}
                                        {item.categories.stationery && item.categories.stationery.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Stationery</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                {/* <th width={'100px'}>Qty</th> */}
                                                                {/* <th width={'145px'}>Unit Price (Rs.)</th> */}
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.stationery.map((element, index) => {
                                                                return (
                                                                    <tr >
                                                                        <td>{element.pname}</td>
                                                                        {/* <td>{element.qty}</td> */}
                                                                        {/* <td>₹{element.price}</td> */}
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </>
                                            : ''}
                                        {item.categories.uniform && item.categories.uniform.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Uniform</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                <th>Stitching</th>
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.uniform.map((element, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{element.pname}</td>
                                                                        <td>
                                                                            {element.withStitching ? (
                                                                                <span>
                                                                                    With Stitching
                                                                                    {element.measurementData && (
                                                                                        <span className='text-muted'> &nbsp;(Size: {element.measurementData.size}, Gender: {element.measurementData.gender})</span>
                                                                                    )}
                                                                                </span>
                                                                            ) : 'Without Stitching'}
                                                                        </td>
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {item.categories.uniform.filter(el => el.withStitching && el.measurementData).map((el, mIdx) => {
                                                    const d = el.measurementData;
                                                    const measurementFields = [
                                                        { name: 'chestBust', label: 'Chest / Bust (inches)' },
                                                        { name: 'waist', label: 'Waist (inches)' },
                                                        { name: 'hip', label: 'Hip (inches)' },
                                                        { name: 'shoulderWidth', label: 'Shoulder Width (inches)' },
                                                        { name: 'neck', label: 'Neck (inches)' },
                                                        { name: 'ankle', label: 'Ankle (inches)' },
                                                        { name: 'sleeveLength', label: 'Sleeve Length (inches)' },
                                                        { name: 'upperArmBicep', label: 'Upper Arm / Bicep (inches)' },
                                                        { name: 'wrist', label: 'Wrist (inches)' },
                                                        { name: 'armholeScye', label: 'Armhole / Scye (inches)' },
                                                        { name: 'frontLength', label: 'Front Length (inches)' },
                                                        { name: 'fullBodyLength', label: 'Full Body Length (inches)' },
                                                        { name: 'inseam', label: 'Inseam (inches)' },
                                                        { name: 'outseamSideLength', label: 'Outseam / Side Length (inches)' },
                                                        { name: 'thigh', label: 'Thigh (inches)' },
                                                        { name: 'knee', label: 'Knee (inches)' },
                                                    ];
                                                    const filledFields = measurementFields.filter(f => d.measurements && d.measurements[f.name] != null && d.measurements[f.name] !== '');
                                                    return (
                                                        <div className='card mb-2' key={mIdx} style={{ backgroundColor: '#f8f9fa' }}>
                                                            <div className='card-body py-2'>
                                                                <p className='mb-2 text-black'><strong>Measurement Details — {el.pname}</strong></p>
                                                                <div className='row mb-1'>
                                                                    <div className='col-sm-3'>
                                                                        <small className='text-muted d-block'>Gender</small>
                                                                        <strong>{d.gender || '—'}</strong>
                                                                    </div>
                                                                    <div className='col-sm-3'>
                                                                        <small className='text-muted d-block'>Size</small>
                                                                        <strong>{d.size || '—'}</strong>
                                                                    </div>
                                                                </div>
                                                                {filledFields.length > 0 && (
                                                                    <>
                                                                        <hr className='my-2' />
                                                                        <div className='row'>
                                                                            {filledFields.map(f => (
                                                                                <div className='col-sm-4 mb-1' key={f.name}>
                                                                                    <small className='text-muted d-block'>{f.label}</small>
                                                                                    <strong>{d.measurements[f.name]}</strong>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                            : ''}
                                        {item.categories.clothing && item.categories.clothing.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Clothing</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                {/* <th width={'100px'}>Qty</th> */}
                                                                {/* <th width={'145px'}>Unit Price (Rs.)</th> */}
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.clothing.map((element, index) => {
                                                                return (
                                                                    <tr >
                                                                        <td>{element.pname}</td>
                                                                        {/* <td>{element.qty}</td> */}
                                                                        {/* <td>₹{element.price}</td> */}
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </>
                                            : ''}
                                        {item.categories.accessories && item.categories.accessories.length > 0 ?
                                            <>
                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Accessories</sapn></h6>
                                                <div className='table-responsive mt-3 mb-3'>
                                                    <table className='table table-bordered'>
                                                        <thead className='thead thead-dark'>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                {/* <th width={'100px'}>Qty</th> */}
                                                                {/* <th width={'145px'}>Unit Price (Rs.)</th> */}
                                                                <th width={'115px'}>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.categories.accessories.map((element, index) => {
                                                                return (
                                                                    <tr >
                                                                        <td>{element.pname}</td>
                                                                        {/* <td>{element.qty}</td> */}
                                                                        {/* <td>₹{element.price}</td> */}
                                                                        <td>₹{element.total}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </>
                                            : ''}
                                    </div>

                                ))}
                            </> : ''}
                        </div>
                        <div className="row  text-black">
                            <div className="col-sm-12">
                                <strong>Order Total:</strong> {this.state.order.orderTotal}
                            </div>
                            <div className="col-sm-12">
                                <strong>Shipping Charges:</strong> {this.state.order.shippingCharges}
                            </div>
                            <div className="col-sm-12">
                                <strong>Final Total:</strong> {this.state.order.orderTotal + this.state.order.shippingCharges}
                            </div>
                        </div>
                    </div>
                </div>

                <footer className="text-center mt-4">
                    <div className="btn-group btn-group-sm d-print-none">
                        {" "}
                        <a
                            href="javascript:window.print()"
                            className="btn btn-light border text-black-50 shadow-none"
                        >
                            <i className="fa fa-print" /> Print
                        </a>
                        {" "}
                    </div>
                </footer>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedOrderId: getSelectedOrderId(state),
    }
}

const mapDispatchToProps = (dispatch) => ({
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ViewOrderDetails);
